var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmonstrDownload13Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download-13-icon",
    d: "M461.4,243.858c0,50.852-41.371,92.221-92.221,92.221h-35.596v-40h35.596 c28.795,0,52.221-23.426,52.221-52.221c0-35.412-23.816-53.746-49.18-53.844c-1.303-58.902-40.637-84.982-78.664-84.982 c-50.307,0-70.973,38.08-76.131,52.662c-20.51-29.582-76.176-7.248-64.641,32.348C118.25,183.78,90.6,209.78,90.6,243.858 c0,28.795,23.428,52.221,52.223,52.221h40.762v40h-40.762c-50.852,0-92.223-41.369-92.223-92.221 c0-41.408,27.561-77.127,66.154-88.463c10.854-36.998,49.783-58.686,86.932-48.779c22.24-26.299,54.773-41.584,89.871-41.584 c57.115,0,105.365,40.816,115.781,95.777C440.941,176.013,461.4,207.944,461.4,243.858z M305.551,293.771 c0-30.76,6.055-48.484,31.926-56.836c-20.066-8.453-125.037-28.816-125.037,67.021c0,32.186,0,58.908,0,58.908h-37.406 l83.963,84.104l83.963-84.104h-37.408C305.551,362.864,305.551,320.659,305.551,293.771z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmonstrDownload13Icon);
export default __webpack_public_path__ + "static/media/iconmonstr-download-13-icon.3ad5adb41859f46dfcbd775124558f78.svg";
export { ForwardRef as ReactComponent };